import api from './api';

interface Localidad {
    codigoCiudad: number;
    nombreCiudad?: string;
    codigoProvincia?: number;
    codigoRuta?: number;
    codigoPostal?: string;
    nombreProvincia?: string;
}

interface LocalidadSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
    codigoProvincia?: number;
}

interface LocalidadPagedResult {
    items: Localidad[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const localidadService = {
    getLocalidades: async (params: LocalidadSearchParams): Promise<LocalidadPagedResult> => {
        const response = await api.get<LocalidadPagedResult>('/api/localidades', { params });
        return response.data;
    },

    getLocalidad: async (codigoCiudad: number): Promise<Localidad> => {
        const response = await api.get<Localidad>(`/api/localidades/${codigoCiudad}`);
        return response.data;
    },

    createLocalidad: async (localidad: Localidad): Promise<Localidad> => {
        const response = await api.post<Localidad>('/api/localidades', localidad);
        return response.data;
    },

    updateLocalidad: async (codigoCiudad: number, localidad: Localidad): Promise<void> => {
        await api.put(`/api/localidades/${codigoCiudad}`, localidad);
    },

    deleteLocalidad: async (codigoCiudad: number): Promise<void> => {
        await api.delete(`/api/localidades/${codigoCiudad}`);
    }
};

export default localidadService; 